import React from "react";
import ReactDataTable from "../../../components/ReactDataTable";
import { useReportTimesheetContext } from "../../../context/ReportTimsheetContex";
import { DiscrepancyResponse, leaveReportPayload } from "../../../model/timesheet";
import { formatAsSevenDigitNumber } from "../../../helper/convertionHealper";
import moment from "moment";

const
  DiscrepancyReportPage: React.FC = () => {
    const [startDate, setStartDate] = React.useState<Date | null>(null);
    const [endDate, setEndDate] = React.useState<Date | null>(null);
    const { DiscrepancyReportList, getDiscrepancyReportList } =
      useReportTimesheetContext();

    const excelSheetHeader: string[] = [
      "Employee ID",
      "Employee Name",
      "Department",
      "Manager",
    ];

    const columns = [
      {
        name: "Employee ID",
        selector: (row: DiscrepancyResponse) => formatAsSevenDigitNumber(row.employee_id),
        sortable: true,
      },
      {
        name: "Employee Name",
        selector: (row: DiscrepancyResponse) => row.ldap_uid,
        sortable: true,
      },
      {
        name: "Department",
        selector: (row: DiscrepancyResponse) => row.department,
        sortable: true,
      },
      {
        name: "Manager",
        selector: (row: DiscrepancyResponse) => row.manager,
        sortable: true,
      },
      {
        name: "Project End date",
        selector: (row: DiscrepancyResponse) => row.unassigned_start_date ? moment(row.unassigned_start_date).format("DD-MM-YYYY") : "N/A",
        sortable: true,
      },
      {
        name: "Number of Days",
        selector: (row: DiscrepancyResponse) => row.total_unassigned_days ? row.total_unassigned_days : "N/A",
        sortable: true,
      }

    ];

    React.useEffect(() => {
      // if (startDate && endDate) {
      const payload: leaveReportPayload = {
        start_date: startDate ? moment(startDate).format("DD-MM-YYYY") : null,
        end_date: startDate ? moment(endDate).format("DD-MM-YYYY") : null,
      };
      getDiscrepancyReportList(payload);
      // }
    }, []);

    const ReportListData = React.useMemo(() => {
      return DiscrepancyReportList?.map((item) => ({
        ...item,
        employee_id: formatAsSevenDigitNumber(item.employee_id),
      }));
    }, [DiscrepancyReportList]);

    // const refreshTable = useCallback(() => {
    //   setEndDate(null);
    //   setStartDate(null);
    //   setDiscrepancyReportList([]);
    // }, []);

    return (
      <div>
        {/* <div className=' gap-x-4 gap-y-4 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 border-b pb-5 border-gray-200'>
        <div>
          <label
            htmlFor='Start Date'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400'
          >
            Start date <span className='text-red-400'>*</span>
          </label>
          <div className='mt-2 flex items-center border border-gray-300 rounded-lg'>
            <CustomDatePicker
              onChange={setStartDate}
              selectedDate={startDate}
              isClearable={true}
              dateFormat='dd/MM/yyyy'
            />
          </div>
        </div>
        <div>
          <label
            htmlFor='End Date'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400'
          >
            End Date <span className='text-red-400'>*</span>
          </label>
          <div className='mt-2'>
            <CustomDatePicker
              onChange={setEndDate}
              selectedDate={endDate}
              minDate={moment(startDate).isValid() ? moment(startDate).toDate() ?? null : new Date()}
              isClearable={true}
              dateFormat='dd/MM/yyyy'
            />
          </div>
        </div>

        <div className='flex space-x-4'>
          <button
            onClick={() => getLeavedetails()}
            className='flex  items-center px-4 py-2 mt-9 text-sm border border-gray-200 bg-white dark:bg-gray-900 dark:border-gray-900 hover:bg-gray-200 text-gray-600 rounded-lg focus:outline-none '
          >
            <FcSearch className='h-5 w-5 text-white  mr-2' /> Search
          </button>
          <button
            onClick={() => refreshTable()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <ArrowPathIcon className='h-5 w-5 text-white mr-2' /> Reset
          </button>
        </div>
      </div> */}
        <ReactDataTable
          columns={columns}
          data={ReportListData ?? []}
          showFilter={ReportListData ? true : false}
          showExport={true}
          actionOption={false}
          ReportName={'DiscrepancyReport'}
          searchLabelName='Search by Employee ID, Employee Name, etc'
          excelSheetHeader={excelSheetHeader}
        />
      </div>
    );
  };

export default DiscrepancyReportPage;
